/**
 * @generated SignedSource<<483adc7023cc936afadc51d22ed47c0a>>
 * @relayHash 22a6dcd801565f4eaaa1b44a3046d694
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 904223289e703cafc1823d4260ed098fbfba584faf5e6868ec496ab7ff8da9f7

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraClassificationLevelSource = "ISSUE" | "PROJECT" | "%future added value";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateDataClassificationFieldInput = {
  id: string;
  operation: JiraDataClassificationFieldOperationInput;
};
export type JiraDataClassificationFieldOperationInput = {
  classificationLevel?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type ui_updateDataClassificationFieldMutation$variables = {
  input: JiraUpdateDataClassificationFieldInput;
};
export type ui_updateDataClassificationFieldMutation$data = {
  readonly jira: {
    readonly updateDataClassificationField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly classificationLevel: {
          readonly color: {
            readonly colorKey: string | null | undefined;
            readonly id: string | null | undefined;
          } | null | undefined;
          readonly definition: string | null | undefined;
          readonly guideline: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly classificationLevelSource: JiraClassificationLevelSource | null | undefined;
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_updateDataClassificationFieldMutation$rawResponse = {
  readonly jira: {
    readonly updateDataClassificationField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly classificationLevel: {
          readonly color: {
            readonly colorKey: string | null | undefined;
            readonly id: string | null | undefined;
          } | null | undefined;
          readonly definition: string | null | undefined;
          readonly guideline: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly classificationLevelSource: JiraClassificationLevelSource | null | undefined;
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_updateDataClassificationFieldMutation = {
  rawResponse: ui_updateDataClassificationFieldMutation$rawResponse;
  response: ui_updateDataClassificationFieldMutation$data;
  variables: ui_updateDataClassificationFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraDataClassificationFieldPayload",
        "kind": "LinkedField",
        "name": "updateDataClassificationField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraDataClassificationField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "fieldId"
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "classificationLevelSource"
              },
              {
                "concreteType": "JiraClassificationLevel",
                "kind": "LinkedField",
                "name": "classificationLevel",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "colorKey"
                      }
                    ]
                  },
                  {
                    "alias": "guideline",
                    "kind": "ScalarField",
                    "name": "guidelines"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "definition"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_updateDataClassificationFieldMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_updateDataClassificationFieldMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "904223289e703cafc1823d4260ed098fbfba584faf5e6868ec496ab7ff8da9f7",
    "metadata": {},
    "name": "ui_updateDataClassificationFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "126194a29e36435bded6eaa25bd49470";

export default node;
